import React from 'react'
import {AiFillInstagram} from 'react-icons/ai'
import {FaGithub} from 'react-icons/fa'
import {AiFillYoutube} from 'react-icons/ai'

const HeaderSocials = () => {
  return (
    <div className="header__socials">
        <a href="https://www.instagram.com/at_a_glance_official/" target="_blank"><AiFillInstagram/></a>
        <a href="https://github.com/at-a-glance-official" target="_blank"><FaGithub/></a>
        <a href="https://www.youtube.com/@ataglanceofficial" target="_blank"><AiFillYoutube/></a>
    </div>
  )
}

export default HeaderSocials